import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GuardService } from './services/guard.service';
import { LoginGuard } from './services/login-guard.guard';




const routes: Routes = [
  {
    path: 'buscador',
    loadChildren: () =>
      import('./pages/cotiza/cotiza.module').then((m) => m.CotizaModule),
  },
  {
    path: 'buscador/:marca',
    loadChildren: () =>
      import('./pages/cotiza/cotiza.module').then((m) => m.CotizaModule),
  },
  {
    path: 'buscador/:marca/:submarca',
    loadChildren: () =>
      import('./pages/cotiza/cotiza.module').then((m) => m.CotizaModule),
  },
  {
    path: 'buscador/:marca/:submarca/:version',
    loadChildren: () =>
      import('./pages/cotiza/cotiza.module').then((m) => m.CotizaModule),
  },
  {
    path: 'buscador/:marca/:submarca/:version/:anio',
    loadChildren: () =>
      import('./pages/cotiza/cotiza.module').then((m) => m.CotizaModule),
  },
  {
    path: 'planes',
    loadChildren: () =>
      import('./pages/planes/planes.module').then((m) => m.PlanesModule),
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./pages/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'landing',
    loadChildren: () =>
      import('./pages/landing-general/landing-general.module').then(
        (m) => m.LandingGeneralModule
      ),
  },
  {
    path: 'comunicados',
    loadChildren: () =>
      import('./pages/boletin/boletin.module').then(
        (m) => m.BoletinModule
      ),
  },
  {
    path: 'profile',
    canActivate: [GuardService],
    loadChildren: () =>
      import('./pages/profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: 'cotizador',
    loadChildren: () =>
      import('./pages/quoter/quoter.module').then((m) => m.QuoterModule),
  },
  {
    path: 'cotizador/:marca/:submarca/:version/:anio/:producto',
    loadChildren: () =>
      import('./pages/quoter/quoter.module').then((m) => m.QuoterModule),
  },
  {
    path: 'cotizador-credito/:marca/:submarca/:version/:anio/:producto',
    loadChildren: () =>
      import('./pages/quoter-credit/quoter-credit.module').then((m) => m.QuoterCreditModule),
  },
  {
    path: 'genera-oportunidad',
    canActivate: [LoginGuard],
    canLoad: [LoginGuard],
    loadChildren: () =>
      import('./pages/buro/buro.module').then((m) => m.BuroModule),
  },
  {
    path: 'comparar-unidad',
    canActivate: [LoginGuard],
    canLoad: [LoginGuard],
    loadChildren: () =>
      import('./pages/comparator/comparator.module').then((m) => m.ComparatorModule),
  },
  {
    path: 'read-qr',
    loadChildren: () =>
      import('./pages/read-qr/read-qr.module').then((m) => m.ReadQrModule),
  },
  {
    path: 'download',
    loadChildren: () => 
    import('./pages/download-files/download-files.module').then((m) => m.DownloadFilesModule)
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '/home',
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled'
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
